<template>
  <div class="bonuses">
    <div class="bonuses__row" v-if="idx !== 4">
      <div class="bonuses__col"
           v-if="user.bonuses_extended[i] && user.bonuses_extended[i].label.indexOf('Итого') === -1"
           v-for="i in GenKeys(idx)"
           :key="i"
           :class="{empty: !user.bonuses_extended[i].label}"
      >
        <span class="bonuses__label">{{user.bonuses_extended[i].label}}</span>
        <span class="bonuses__value clickable" @click="$router.push(`bonuses/${user.bonuses_extended[i].id}`)">{{user.bonuses_extended[i].sum}}</span>
        <span class="bonuses__currency" v-if="user.bonuses_extended[i].sum && isBy">
          ({{GetSubWithCurrency(user.bonuses_extended[i].sum)}})
        </span>
      </div>
    </div>

    <div class="bonuses__row" v-else>
      <template v-if="isDealer">
        <div class="bonuses__col">
          <span class="bonuses__label">Доступно баллов:</span>
          <span class="bonuses__value clickable" @click="$router.push('/purse')">{{user.avaliable_bonuses}}</span>
          <span class="bonuses__currency" v-if="user.avaliable_bonuses && isBy">
            ({{GetSubWithCurrency(user.avaliable_bonuses)}})
          </span>
        </div>
        <div class="bonuses__col">
          <span class="bonuses__label">Доступно с {{isBy ? '' : 'учетом '}}НДФЛ:</span>
          <span class="bonuses__value clickable" @click="$router.push('/purse')">{{user.avaliable_bonuses_with_ndfl}}</span>
          <span class="bonuses__currency" v-if="user.avaliable_bonuses_with_ndfl && isBy">
            ({{GetSubWithCurrency(user.avaliable_bonuses_with_ndfl)}})
          </span>
        </div>
      </template>
      <div class="bonuses__col">
        <span class="bonuses__label">Итого баллов:</span>
        <span class="bonuses__value clickable" @click="$router.push('bonuses/null')">{{user.total_bonuses}}</span>
        <span class="bonuses__currency" v-if="user.total_bonuses && isBy">
          ({{GetSubWithCurrency(user.total_bonuses)}})
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['idx'],
  computed: {
    user() { return this.$store.state.user; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    isApproved() { return !!(this.$store.getters.isApproved); },
    isRus() { return this.$store.getters.isRus; },
    isBy() { return this.$store.getters.isBy; },
    isKz() { return this.$store.getters.isKz; },
  },
  methods: {
    GenKeys(idx) {
      switch (idx) {
        case 2: return [3, 4, 5];
        case 3: return [6, 7];
        default: return [0, 1, 2];
      }
    },
    GetSubWithCurrency(bonus) {
      if (this.user.currency_rate && this.user.currency_rate.payments_rate) {
        return `${Math.round(bonus / this.user.currency_rate.payments_rate)} ${this.isBy ? 'BYN' : 'KZT'}`;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../assets/scss/variables';

.bonuses {
  &__col {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    &.empty {
      display: none;
    }
  }
  &__value {
    color: variables.$wb-bonus-value-color;
    padding-left: 6px;
    font-weight: bold;

    &.clickable {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
